import combineActionHandlers from "@web-monorepo/infra/combineActionHandlers";
import { PodInstallFunction } from "@web-monorepo/shared/podInfra";
import filter from "lodash/filter";
import get from "lodash/get";
import map from "lodash/map";
import setupFetch from "src/utils/setupFetch";

const initialState = {};
const STATE_KEY = "students";

// enum Attendance {
//   "present",
//   "tardy",
//   "absent",
// }

export type Student = {
  _id: string;
  firstName: string;
  lastName: string;
  avatar: string;
  currentAttendance?: string;
};

export type StudentSlice = {
  [STATE_KEY]: Student[];
};

const {
  actionCreator: fetchStudents,
  saga: fetchStudentsSaga,
  reducer: fetchStudentsReducer,
} = setupFetch({
  stateKey: STATE_KEY,
  makePath: ({ classId }: { classId: string }) => `/api/dojoClass/${classId}/student`,
  makeUpdatePath: () => "students",
});

type Selector = (state: StudentSlice) => Student[] | null;

export { fetchStudents };
export const selectStudents: Selector = (state: StudentSlice) => {
  const students: Student[] | null = get(state, [STATE_KEY, "students"]);
  if (!students) return null;
  return map(students, (s) => s);
};

const isPresent = (student: Student) => {
  return student.currentAttendance === "present" || student.currentAttendance === "tardy";
};

export const selectAttendingStudents: Selector = (state: StudentSlice) => {
  const students = selectStudents(state);
  if (!students) return null;
  return filter(students, isPresent);
};

const reducer = combineActionHandlers(initialState, [fetchStudentsReducer]);

const install: PodInstallFunction = (installReducer, installSaga) => {
  installReducer(STATE_KEY, reducer);
  installSaga(fetchStudentsSaga);
};

export default install;
